import { FC } from 'react'
import { useAppSelector } from '../../../hooks'
import { BarChart } from '@mui/x-charts/BarChart'
import { Helmet } from 'react-helmet-async'
import PageTitleWrapper from '../../../components/PageTitleWrapper'
import BillsPaymentReportHeader from './PageHeader'
import PageContainerWrapper from '../../../components/PageContainerWrapper'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { currencyFormatter } from '../../../utils'

export interface BillsPaymentReportProps {}

export const BillsPaymentReport: FC<BillsPaymentReportProps> = () => {
  const { data } = useAppSelector((state) => state.billsPaymentChartState)

  return (
    <>
      <Helmet>
        <title>Month-Wise Bills/Payment</title>
      </Helmet>
      <PageTitleWrapper>
        <BillsPaymentReportHeader />
      </PageTitleWrapper>
      <PageContainerWrapper>
        {data?.billingCharts && (
          <>
            <TableContainer>
              <Table aria-label="summary table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Invoices Sum</TableCell>
                    <TableCell align="center">Payment Sum</TableCell>
                    <TableCell align="center">Invoices − Payments (in date range)</TableCell>
                    <TableCell align="center">Total Discount Given</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow sx={{ backgroundColor: 'white' }}>
                    <TableCell align="center">
                      <Typography variant="h5">
                        {currencyFormatter.format(data.invoiceSum)}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="h5">
                        {currencyFormatter.format(data.paymentSum)}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="h5">
                        {currencyFormatter.format(
                          data.invoiceSum - data.paymentSum
                        )}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="h5">
                        {currencyFormatter.format(data.discountSum)}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Typography sx={{ fontSize: 14, backgroundColor: '#e8f5e9', color: '#2e7d32', p: 1.5, mb: 2, borderRadius: 1 }}>
              Create an invoice for every bill so this report stays accurate.
            </Typography>
            <BarChart
              sx={{ mt: 5 }}
              dataset={data.billingCharts}
              series={[
                {
                  dataKey: 'invoiceSum',
                  label: 'Invoices',
                  color: '#ff9800',
                  stack: 'bills',
                },
                {
                  dataKey: 'discountSum',
                  label: 'Discount',
                  color: '#32CD32',
                  stack: 'bills',
                },
                { dataKey: 'paymentSum', label: 'Payment', color: '#582899' },
              ]}
              height={450}
              xAxis={[{ dataKey: 'month', scaleType: 'band' }]}
              margin={{ top: 50, bottom: 40, left: 100, right: 100 }}
            />
          </>
        )}
      </PageContainerWrapper>
    </>
  )
}

export default BillsPaymentReport
